export const fetchSurvey = resp => {
  return {
    type: "FETCH_SURVEY",
    payload: resp
  };
};
export const setResponse = resp => {
  return {
    type: "SET_RESPONSE",
    payload: resp
  };
};
export const fetchUserResponse = resp => {
  return {
    type: "FETCH_USER_RESPONSE",
    payload: resp
  };
};
export const fetchSurveyStats = resp => {
  return {
    type: "FETCH_SURVEY_STATS",
    payload: resp
  };
};
export const setSelectedChoice = choiceId => {
  return {
    type: "SET_SELECTED_CHOICE",
    choiceId
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/survey.js